import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { SegmentRow } from "./use-segments";

// GET /api/settings/segments/:id — single segment.
export function useSegment(id: string | undefined) {
  return useQuery<SegmentRow, ApiClientError>({
    queryKey: queryKeys.settings.segment(id ?? ""),
    queryFn: () => apiFetch<SegmentRow>(`/settings/segments/${id}`),
    enabled: !!id,
  });
}
